module.exports = __webpack_public_path__ + "img/202312_03.039550c4.jpg";